import {Component} from '@angular/core';
import {FormControl} from '@angular/forms';
import {FormInputComponent, CustomFieldConfig, DataService, NotificationService} from '@vendure/admin-ui/core';
import gql from 'graphql-tag';
import {generatePublicId} from '@vendure/core/dist/common/generate-public-id';

@Component({
  selector: 'vdr-app-file-input',
  templateUrl: './app-file-input.component.html',
  styleUrls: ['./app-file-input.component.scss'],
})
export class AppFileInputComponent implements FormInputComponent<CustomFieldConfig> {
  constructor(private dataService: DataService, private notificationService: NotificationService) {}
  isListInput?: boolean | undefined;
  readonly: boolean;
  formControl: FormControl;
  config: CustomFieldConfig;

  accept: string;
  UPLOAD_WX_FILE = gql`
    mutation uploadToPrivate($input: UploadPrivateInput!) {
      uploadToPrivate(input: $input)
    }
  `;

  ngOnInit() {}

  selectFile(event: Event) {
    const files = (event.target as HTMLInputElement).files;
    if (files?.length) {
      const temp = Array.from(files);
      console.log(files[0], temp[0]);
      // const title = temp[0].name;
      this.dataService
        .mutate<{uploadToPrivate: string}>(this.UPLOAD_WX_FILE, {
          input: {
            file: temp[0],
            folderName: generatePublicId(),
          },
        })
        .subscribe(res => {
          this.formControl.setValue(res.uploadToPrivate);
          this.notificationService.success('上传成功');
        });
    }
  }
}
